import { useState } from "react";

const useModalState = () => {
  const [selectedBookingId, setSelectedBookingId] = useState(null);
  const [selectedShiftId, setSelectedShiftId] = useState(null);
  const [sourceAccountId, setSourceAccountId] = useState(null);
  const [
    selectedTimesheetMemberRowId,
    setSelectedTimesheetMemberRowId
  ] = useState(null);
  const [
    selectedTimesheetMemberRowData,
    setSelectedTimesheetMemberRowData
  ] = useState(null);
  const [selectedTimesheetStatus, setSelectedTimesheetStatus] = useState("");

  const handleOpenBookingModal = (bookingId, sourceAccountId) => {
    setSelectedBookingId(bookingId);
    setSourceAccountId(sourceAccountId);
  };

  const handleCloseBookingModal = () => {
    setSelectedBookingId(null);
    setSourceAccountId(null);
  };

  const handleOpenShiftModal = shiftId => {
    setSelectedShiftId(shiftId);
  };

  const handleCloseShiftModal = () => {
    setSelectedShiftId(null);
  };

  const handleOpenTimesheetModal = (
    timesheetId,
    sourceAccountId,
    timesheetStatus,
    timesheetMemberRowData = null
  ) => {
    setSelectedTimesheetMemberRowId(timesheetId);
    setSelectedTimesheetMemberRowData(timesheetMemberRowData);
    setSourceAccountId(sourceAccountId);
    setSelectedTimesheetStatus(timesheetStatus);
  };

  const handleCloseTimesheetModal = () => {
    setSelectedTimesheetMemberRowId(null);
    setSelectedTimesheetMemberRowData(null);
    setSourceAccountId(null);
    setSelectedTimesheetStatus("");
  };

  return {
    selectedBookingId,
    selectedShiftId,
    sourceAccountId,
    selectedTimesheetMemberRowId,
    selectedTimesheetMemberRowData,
    selectedTimesheetStatus,
    handleOpenBookingModal,
    handleCloseBookingModal,
    handleOpenShiftModal,
    handleCloseShiftModal,
    handleOpenTimesheetModal,
    handleCloseTimesheetModal
  };
};

export default useModalState;
